// There is no foreground presentation to configure in a browser tab: the web build registers no
// push device (see lib/push-notifications.web.ts), so no notification is ever delivered for a
// handler to rule on, and expo-notifications' handler module is not implemented for web. Setting
// one here would be a rule about an event that cannot happen.
//
// The export mirrors the native module so the root layout calls it unconditionally.

export function configureForegroundNotifications(): void {
    // Intentionally empty — see the file comment.
}
